/**
 * 파일명에서 행사 일시 추출 — "20260909", "20260827-1900", "20260827_1900" 패턴
 * (현장 파일명 관례 실측: wumuji "20260827-1900.mp4" 등).
 *
 * 프리필 전용이다: 값은 행사 일시 입력에 채워질 뿐, 사용자가 보고 고칠 수 있다 —
 * 자동 확정하지 않는다. 시간이 없으면 19:00 기본(저녁 행사 관례 — 역시 프리필일 뿐).
 * 오인 방지: 실제 달력 날짜여야 하고 올해 ±2년 범위만 인정(전화번호·ID 숫자 배제).
 * 반환: datetime-local 형식("YYYY-MM-DDTHH:mm") 또는 null.
 */
export function eventDateFromFilename(name: string): string | null {
  const m = name.match(/(20\d{2})(\d{2})(\d{2})(?:[-_]([01]\d|2[0-3])[:h]?([0-5]\d))?/);
  if (!m) return null;
  const [, y, mo, d, hh, mm] = m;
  const Y = +y, M = +mo, D = +d;
  const dt = new Date(Y, M - 1, D);
  if (dt.getFullYear() !== Y || dt.getMonth() !== M - 1 || dt.getDate() !== D) return null;
  const nowY = new Date().getFullYear();
  if (Y < nowY - 2 || Y > nowY + 2) return null;
  return `${y}-${mo}-${d}T${hh ?? '19'}:${mm ?? '00'}`;
}
